import { render } from "./RobotPay.vue?vue&type=template&id=61dcc3af"
import script from "./RobotPay.vue?vue&type=script&lang=js"
export * from "./RobotPay.vue?vue&type=script&lang=js"

import "./RobotPay.vue?vue&type=style&index=0&id=61dcc3af&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__